import { render, staticRenderFns } from "./shouye.vue?vue&type=template&id=14dab6b9&scoped=true&"
import script from "./shouye.vue?vue&type=script&lang=js&"
export * from "./shouye.vue?vue&type=script&lang=js&"
import style0 from "./shouye.vue?vue&type=style&index=0&id=14dab6b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dab6b9",
  null
  
)

export default component.exports